import { graphqlFetch } from '@pylot-data/graphqlFetch'
import { sideblogCategory } from '@pylot-data/hooks/blog/graphql/blogQuery'
import type { RequestInit } from '@vercel/fetch'

export interface Blogsidebarcat {
    identifier: string
    category_id: number
    title: string
    category_url: string
    posts_count: number
    parent_category_id: number
}

export type BlogsidebarCategory = {
    blogCategories: {
        items: Blogsidebarcat[]
    }
}

export type GetBlogsidebarCategory = BlogsidebarCategory

async function getCategorySidebar({
    fetchOptions,
    locale
}: {
    pageSize: number
    fetchOptions?: RequestInit
    locale?: string
}): Promise<GetBlogsidebarCategory | undefined | null> {
    const categoryDataPromise = graphqlFetch<null, GetBlogsidebarCategory>({
        query: sideblogCategory,
        fetchOptions,
        locale
    })
    const [categoryData] = await Promise.all([categoryDataPromise])
    return categoryData.data
}

export default getCategorySidebar
